import { Suspense, useContext } from 'react';
import { useRemoteComponent } from 'zf-web-components';
import { RootContext } from '@stores';
import { useApp } from '../../hooks';
import { DefaultToolsMenu } from './default-tools-menu';
import { getRemoteUrl } from './util';
import type { ReactElement } from 'react';

export function ToolsMenu(): ReactElement {
  const { app } = useApp();
  const remote = getRemoteUrl(app);

  const { Component: LazyToolsMenu, loading } = useRemoteComponent<{ tenantName?: string; name?: string }>(remote, 'ToolsMenu');

  const root = useContext(RootContext);
  const { user } = root;

  if (loading) {
    return <></>;
  }

  // 如果没有远程组件或者远程组件加载失败，则显示默认的工具菜单
  if (LazyToolsMenu == null) {
    return <DefaultToolsMenu />;
  }

  return (
    <Suspense fallback={<></>}>
      <LazyToolsMenu tenantName={user?.tenantName} name={user?.name} />
    </Suspense>
  );
}
